import React from "react";
import PropTypes from "prop-types";
import { Button, Dropdown } from "antd";
import { Link } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";

import { updateUI } from "../../store/actions/shipment";

const ShipmentDropdownSingleFields = (props) => {
  const { name, id, record } = props;

  const dispatch = useDispatch();
  const {
    isMarkAsCompletedOpen,
    isCloneOpen,
    singleDeleteShipConfirmed,
    singleCancelShipConfirmed,
    isEditShipmentOpen,
  } = useSelector((state) => ({
    isMarkAsCompletedOpen: state.shipment.ui.edit.updateState,
    singleDeleteShipConfirmed: state.shipment.ui.delete.singleDelete,
    singleCancelShipConfirmed: state.shipment.ui.cancel.singleCancel,
    isCloneOpen: state.shipment.ui.clone.isClone,
    isEditShipmentOpen: state.shipment.ui.editShipment.isEditShipment,
  }));
  const handleCancel = () => {
    dispatch(
      updateUI({
        key: "cancel",
        value: {
          singleCancel: !singleCancelShipConfirmed,
          cancelField: {
            id,
            name,
            record,
          },
        },
      })
    );
  };
  const handleDelete = () => {
    dispatch(
      updateUI({
        key: "delete",
        value: {
          singleDelete: !singleDeleteShipConfirmed,
          deletedField: {
            id,
            name,
            record,
          },
        },
      })
    );
  };

  const handleCloneShipment = (actionType) => {
    dispatch(
      updateUI({
        key: "clone",
        value: {
          isClone: !isCloneOpen,
          editRecord: {
            record: {
              ...record,
              editorClone: actionType,
            },
          },
        },
      })
    );
  };

  const handleEditShipment = (actionType) => {
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          isEditShipment: !isEditShipmentOpen,
          editRecord: {
            record: {
              ...record,
              editorClone: actionType,
            },
          },
        },
      })
    );
  };

  const handleMarkAsCompleted = (e) => {
    dispatch(
      updateUI({
        key: "edit",
        value: {
          updateState: !isMarkAsCompletedOpen,
          currentUpdateState: {
            selected: {
              deviceid: record?.deviceid,
              shipmentName: record?.shipmentName,
              location: record?.deviceprofile?.locations
                ?.filter((location) => location?.locationtype === "Destination")
                ?.map((location) => ({
                  latitude: location?.latitude,
                  longitude: location?.longitude,
                })),
            },
            formData: {
            },
          },
        },
      })
    );
  };

  const items = [
    record?.shipmentstate?.toLowerCase() !== "completed" && record?.shipmentstate?.toLowerCase() !== "scheduled"&&record?.shipmentstate?.toLowerCase() !== "cancelled"&& {
      label: (
        <button onClick={handleMarkAsCompleted} className="ats-text-btn">
           Complete Shipment
        </button>
      ),
      key: `${id}-4`,
    },
    record?.shipmentstate?.toLowerCase() !== "completed"&&record?.shipmentstate?.toLowerCase() !== "cancelled"&&{
      label: (
        <button onClick={handleCancel} className="ats-text-btn">
          Cancel Shipment
        </button>
      ),
      key: `${id}-7`,
    },
    record?.shipmentstate?.toLowerCase() !== "completed"&& record?.shipmentstate?.toLowerCase() !== "cancelled"&&{
      label: (
        <button
          onClick={() => handleEditShipment("edit")}
          className="ats-text-btn"
        >
          Edit Shipment
        </button>
      ),
      key: `${id}-3`,
    },
      {
      label: (
        <button
          onClick={() => handleCloneShipment("clone")}
          className="ats-text-btn"
        >
          Clone Shipment
        </button>
      ),
      key: `${id}-6`,
    },
     {
      label: (
        <button onClick={handleDelete} className="ats-text-btn">
          Delete Shipment
        </button>
      ),
      key: `${id}-5`,
    }
  ];

  return (
    <Dropdown
      key={`dropdown-${id}`}
      menu={{
        items,
      }}
      trigger={["click"]}
      overlayClassName="shipment-dropdown-overlay"
    >
      <Button
              className="custom-button-cancel"
              type="default"
              // onClick={deleteShipment}
              shape="round"
              style={{
                fontWeight: "500",
                padding: "20px 24px",
                height: "36px",
                border: "1px solid #d9d9d9",
                boxShadow: "none",
                marginRight: "-10px",
              }}
            >
              <div style={{ fontWeight: "700" }}>Action</div>
            </Button>
    </Dropdown>
  );
};

ShipmentDropdownSingleFields.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  record: PropTypes.any.isRequired,
};

export default ShipmentDropdownSingleFields;
